import { cached } from '@porotutu/react'
import { listQueryOf } from '@porotutu/react/paging'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { CRM_VALIDATION_RULE_SORTABLE } from '../vocabulary'
import { validationRuleQuery, validationRulesQuery } from './queries'

const validationRuleSearch = (raw: Record<string, unknown>) =>
  listQueryOf(raw, CRM_VALIDATION_RULE_SORTABLE)

export const validationRulesRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('validation_rules'),
  path: '/validation-rules',
  validateSearch: validationRuleSearch,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => context.queryClient.query(cached(validationRulesQuery(deps))),
  component: lazyRouteComponent(() => import('./pages'), 'ValidationRulesPage'),
})

export const validationRuleRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('validation_rules'),
  path: '/validation-rules/$id',
  validateSearch: validationRuleSearch,
  loader: ({ context, params }) =>
    context.queryClient.query(cached(validationRuleQuery(params.id))),
  component: lazyRouteComponent(() => import('./pages'), 'ValidationRulePage'),
})

export const validationRuleRoutes = [validationRulesRoute, validationRuleRoute]
